/**
 * `#pricing` — bản tiếng Anh, lấy từ thuộc tính `data-en` trong `template.html` (1012–1025).
 * Hình dạng phải khớp `vi/pricing.ts`; lệch một khoá là lỗi biên dịch.
 */
interface PricingPlanCopy {
  readonly name: string;
  readonly blurb: string;
  readonly price: string;
  readonly features: string;
  readonly highlighted?: boolean;
  readonly badge?: string;
}

export const pricing = {
  eyebrow: 'Pricing',
  heading: 'Plans are being finalised.',
  lead: 'Talk to us in the meantime — we will size a pilot around your team.',
  plans: [
    {
      name: 'Team',
      blurb: 'Small teams getting started.',
      price: 'Price to be announced',
      features: 'Chat, Topic, Voice · Project Manager · Knowledge Base',
    },
    {
      name: 'Business',
      blurb: 'Growing companies with several projects.',
      price: 'Price to be announced',
      features: 'Everything in Team · AI Agents & Skills · Connectors · Wiki',
      highlighted: true,
      badge: 'MOST TEAMS',
    },
    {
      name: 'Enterprise',
      blurb: 'Regulated and large organisations.',
      price: 'Contact sales',
      features: 'On-premise · SSO & audit · Migration & training · SLA',
    },
  ] as readonly PricingPlanCopy[],
};
